import { BaseQueryFn } from "@reduxjs/toolkit/query";
import apiClient from "../api/httpClient";
import { sharedAuthDataService } from "../api/auth/sharedAuthDataService";

export const baseQuery: BaseQueryFn = async (args) => {
  try {
    const token = await sharedAuthDataService.getToken();
    const headers = {
      ...(args.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };

    const result = await apiClient({
      url: args.url,
      method: args.method,
      data: args.body,
      params: args.params,
      headers
    });
    return { data: result.data };
  } catch (axiosError) {
    const error = axiosError as any;
    return {
      error: {
        status: error.response?.status,
        data: error.response?.data || error.message
      }
    };
  }
};
